import script from "./Security.vue?vue&type=script&setup=true&lang=js"
export * from "./Security.vue?vue&type=script&setup=true&lang=js"

import "./Security.vue?vue&type=style&index=0&id=2d111c50&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d111c50"]])

export default __exports__